import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="nk-footer bg-theme-alt section-connect">
      <div className="section section-m pb-0 tc-light ov-h">
        <div className="container py-4">
          {/* Newsletter Block */}
          <div className="nk-block pb-lg-5">
            <div className="row justify-content-center text-center">
              <div className="col-lg-6 col-md-9">
                <div className="wide-auto-sm section-head section-head-sm pdb-r">
                  <h4 className="title title-md">Stay Updated with EBARANGAY</h4>
                  <p style={{ color: '#ff6b6b' }}>Get the latest updates on digital governance and barangay services</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section section-footer section-s tc-light bg-transparent" style={{ marginTop: '-40px' }}>
        <div className="container">
          {/* Footer Block */}
          <div className="nk-block block-footer">
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="wgs wgs-text">
                  <div className="wgs-body">
                    <img
                      src="/logo.png"
                      alt="EBARANGAY"
                      className="ebarangay-logo mb-3"
                      style={{ maxWidth: '120px' }}
                    />
                    <p>
                      Empowering Barangays Through Digital Governance. A cloud-based and
                      secured digital platform designed to modernize barangay operations.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-6 mb-4">
                <div className="wgs wgs-menu">
                  <div className="wgs-head">
                    <h5 className="wgs-title">Quick Links</h5>
                  </div>
                  <div className="wgs-body">
                    <ul className="wgs-links">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/services">Services</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="wgs wgs-menu">
                  <div className="wgs-head">
                    <h5 className="wgs-title">Our Services</h5>
                  </div>
                  <div className="wgs-body">
                    <ul className="wgs-links">
                      <li>
                        <Link to="/services">Barangay Clearances</Link>
                      </li>
                      <li>
                        <Link to="/services">Business Permits</Link>
                      </li>
                      <li>
                        <Link to="/services">Blotters</Link>
                      </li>
                      <li>
                        <Link to="/services">Pet Registrations</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="wgs wgs-contact">
                  <div className="wgs-head">
                    <h5 className="wgs-title">Get in Touch</h5>
                  </div>
                  <div className="wgs-body">
                    <ul className="wgs-links">
                      <li>
                        <em className="fas fa-envelope"></em>
                        <span> info@ebarangay.ph</span>
                      </li>
                      <li>
                        <em className="fas fa-phone"></em>
                        <span> 0968-852-6355</span>
                      </li>
                    </ul>
                    <div style={{ marginTop: '30px' }}>
                      <a
                        href="https://play.google.com/store/apps/details?id=ph.ebarangay.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-md btn-grad btn-round"
                      >
                        <span style={{ color: '#ffffff' }}>Download App</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="wgs wgs-text text-center mb-3">
                  <div className="copyright-text copyright-text-s3 pdt-m">
                    <p>
                      <span className="d-sm-block">
                        Copyright &copy; {currentYear}, EBARANGAY. All rights reserved.
                      </span>
                      <span className="d-sm-block mt-1">
                        <Link to="/terms-and-conditions" style={{ color: 'rgba(255,255,255,0.7)' }}>Terms & Conditions</Link>
                        <span style={{ color: 'rgba(255,255,255,0.5)', margin: '0 8px' }}>|</span>
                        <Link to="/privacy-policy" style={{ color: 'rgba(255,255,255,0.7)' }}>Privacy Policy</Link>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
